import * as React from "react";
const SvgTooltipArrow = props => <svg width={14} height={13} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.5 0L14 13H0L7.5 0Z" fill="#323232" /></svg>;
export default SvgTooltipArrow;